
<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        <span>Cambiar contraseña</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn class="primary elevation-0" @click="$router.go(-1)">
                        <v-icon class="margin">arrow_back</v-icon>&nbsp;
                        Volver
                    </v-btn>
                </v-toolbar>
                <v-container grid-list-xs>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout wrap ma-4>
                            <v-flex md12 sm12>
                                <v-text-field :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                              @click:append="show2 = !show2"
                                              v-on:keyup="textKeyPress"
                                              :rules="[rules.required, rules.min]"
                                              :type="show2 ? 'text' : 'password'"
                                              counter
                                              clearable
                                              v-model="claveActual"
                                              label="Contraseña actual"
                                              hint="Introduzca su contraseña actual"></v-text-field>
                            </v-flex>
                            <v-flex md12 sm12>
                                <v-text-field :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                                              @click:append="show3 = !show3"
                                              v-on:keyup="textKeyPress"
                                              :rules="[rules.required, rules.min]"
                                              :type="show3 ? 'text' : 'password'"
                                              counter
                                              clearable
                                              v-model="nuevaClave"
                                              label="Nueva Contraseña"
                                              hint="Introduzca su nueva contraseña"></v-text-field>
                            </v-flex>
                            <v-flex md12 sm12>
                                <v-text-field :append-icon="show4 ? 'mdi-eye' : 'mdi-eye-off'"
                                              @click:append="show4 = !show4"
                                              v-on:keyup="textKeyPress"
                                              :rules="[rules.required, rules.min]"
                                              :type="show4 ? 'text' : 'password'"
                                              counter
                                              clearable
                                              v-model="reNuevaClave"
                                              label="Re-Nueva Contraseña"
                                              hint="Repita su nueva contraseña"></v-text-field>
                            </v-flex>
                            <v-card-actions class="mb-2 mt-4">
                                <v-btn dark
                                       color="primary"
                                       class="ml-12"
                                       :loading="loading"
                                       :disabled="loading"
                                       @click="submit">
                                    <v-icon class="margin">how_to_reg</v-icon>Cambiar contraseña
                                    <span slot="loader">
                                        <small style="text-transform: lowercase; padding: 0 10px; display:inline-block">cambiando...</small>
                                    </span>
                                </v-btn>
                            </v-card-actions>
                            <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
                        </v-layout>
                    </v-form>
                </v-container>
            </v-card>
            <v-snackbar v-model="showError" color="error" :timeout="8000" right>
                <span v-html="errorMessage">
                </span>
                <!-- Usuario/Contraseña incorrectos -->
                <v-btn dark text @click="showError = false">Cerrar</v-btn>
            </v-snackbar>
        </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import authenticationService from "@/services/authenticationService.js";

export default {
  name: "home",
  data() {
    return {
      showError: false,
      errorMessage: '',
      valid: true,
      loading: false,
      claveActual: "",
      nuevaClave: "",
      reNuevaClave: "",
      show2: false,
      show3: false,
      show4: false,
      password: "Password",
      rules: {
        required: value => !!value || "Dato requerido.",
        min: v => v.length >= 8 || "Mínimo 8 caracteres"
      },
      loading: false
    };
  },
  components: {},
  computed: {
    ...mapState("authentication", ["status", "user"])
},
watch: {
    status: function (val) {
        this.loading = val.logging;
        this.showError = !!val.error;
        if (val.logged) {
            if (this.user.userMustChangePassword) {
                this.$router.push("/cambiar-clave");
            } else {
                const { dispatch } = this.$store;
                dispatch("authentication/passwordChanged");
                this.$router.push("/");
            }
        }
    }
},
  created() {
    this.$store.commit("global/SET_MIGA", [
      { text: "Inicio", href: "/" },
      { text: "Cambiar contraseña", href: "/cambiar-clave" }
    ]);
  },
  methods: {
    ...mapMutations("global", ["SET_AlertMensaje"]),
    textKeyPress: function(e) {
      if (e.keyCode === 13) {
        this.submit();
      }
    },
    submit: function() {
      if (this.$refs.form.validate()) {
        const { claveActual, nuevaClave, reNuevaClave } = this;
        const { dispatch } = this.$store;
        if (
          claveActual &&
          nuevaClave &&
          reNuevaClave &&
          nuevaClave == reNuevaClave
        ) {
          var that = this;
          this.loading = true;
          this.showError = false;
          authenticationService
            .changePassword(this.user.userId, claveActual, nuevaClave)
              .then(res => {
                  if (res.succeeded) {
                      setTimeout(function () {
                          that.SET_AlertMensaje({
                              mensaje: "Se ha cambiado satisfactoriamente la contraseña.",
                              tipo: "success"
                          });
                      }, 500);
                      const { dispatch } = this.$store;

                      if (this.user.userMustChangePassword) {
                          dispatch("authentication/login", {
                              usuario: this.user.username,
                              contrasena: nuevaClave,
                              dominio: this.user.domain,
                              host: this.user.hostname
                          });
                      } else {
                          dispatch("authentication/passwordChanged");
                          that.$router.push("/");
                      }
                  } else {
                      this.showError = true;
                      this.errorMessage = res.errors[0];
                      this.loading = false;
                  }
            });
        }
      }
    }
  }
};
</script>